import React from 'react';
import { cn } from '../../utils/cn';

const StandardButton = ({ 
  children, 
  variant = 'primary', 
  size = 'md',
  type = 'button',
  disabled = false,
  onClick,
  className,
  ...props 
}) => {
  const baseStyles = 'font-semibold transition-all duration-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variants = {
    primary: 'bg-blue-700 hover:bg-blue-800 text-white shadow-sm hover:shadow-md',
    secondary: 'bg-white text-blue-700 border-2 border-blue-700 hover:bg-blue-50',
    outline: 'bg-transparent text-gray-700 border border-gray-300 hover:bg-gray-50',
    ghost: 'bg-transparent text-blue-700 hover:bg-blue-50',
    success: 'bg-green-600 hover:bg-green-700 text-white shadow-sm hover:shadow-md',
    danger: 'bg-red-600 hover:bg-red-700 text-white shadow-sm hover:shadow-md'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        baseStyles,
        variants?.[variant],
        sizes?.[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default StandardButton;